import { render } from "./AddressPediatric.vue?vue&type=template&id=2f22ea94"
import script from "./AddressPediatric.vue?vue&type=script&lang=js"
export * from "./AddressPediatric.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__